export const frontmatter = {"title":"Index Cn"};
export const toc = [];